import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description: "The crosstalk (red arrow, 1’) arriving at the right ear needs to be compensated.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/21/principle/principle-2.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
